<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Informações da Máquina {{ paramsRota.nome }}
      </p>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <ModalLateral
        @fecharModal="rightDrawerOpen = false"
        :rightDrawerOpen="rightDrawerOpen"
        :nomeModal="`Configuração de QrCodes`"
      >
        <template v-slot:conteudo-modal>
          <section class="row">
            <div style="width: 100%" class="q-mt-md">
              <div class="q-ml-sm texto-titulo-input">Nome QrCode</div>
              <q-input outlined dense v-model="nameQr" placeholder="Nome Qr">
              </q-input>
            </div>
            <div style="width: 100%" class="q-mt-sm">
              <div class="q-ml-sm texto-titulo-input">Link QrCode</div>
              <q-input outlined dense v-model="link" placeholder="Link Qr">
              </q-input>
            </div>
          </section>
        </template>
        <template v-slot:botao-modal>
          <q-btn
            class="q-mt-sm"
            color="positive"
            label="Salvar"
            icon="done"
            no-caps
            :disable="!nameQr || !link"
            @click="criarQrcode"
          />
        </template>
      </ModalLateral>
    </div>

    <slots />
    <products />
    <mensagens />
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Data Inicial</div>
        <q-input
          v-model="filtros.dataIncial"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataIncial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>

      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Data Final</div>
        <q-input
          v-model="filtros.dataFinal"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>
    <logs :filtros="filtros" />
    <div class="q-mt-sm">
      <q-table
        title="Configuração de QrCodes"
        flat
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        :rows="rows"
        dense
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <section class="row">
            <q-btn
              icon="qr_code"
              flat
              color="brand-1"
              label="Criar QrCode"
              no-caps
              @click="rightDrawerOpen = true"
            />
          </section>
        </template>
        <template #body-cell-name="props">
          <q-td>
            <span>
              {{ props.row.name }}
            </span>
          </q-td>
        </template>
        <template #body-cell-link="props">
          <q-td>
            <span>
              <a target="_blank" :href="props.row.link">{{ props.row.link }}</a>
            </span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "titulo",
    label: "Titulo",
    field: "titulo",
    align: "left",
  },
  {
    name: "link",
    label: "Link",
    field: "link",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import Products from "../components/Products.vue";
import Slots from "../components/Slots.vue";
import mensagens from "../components/Mensagens.vue";
import ModalLateral from "../../../../components/ModalLateral.vue";
import Logs from "../components/Logs.vue";
export default {
  components: { Products, Slots, mensagens, Logs, ModalLateral },
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const nameQr = ref("");
    const link = ref("");
    const $q = useQuasar();
    const route = useRoute();
    const rows = ref([]);
    const disable = ref(true);
    const rightDrawerOpen = ref(false);
    const filtros = ref({ dataIncial: "", dataFinal: "" });
    const paramsRota = JSON.parse(route.params.id);
    let filter = ref("");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getQrcode = async () => {
      let response = await store.dispatch("maquina/getQr", {
        id: paramsRota.id,
      });

      rows.value = response.data;

      disable.value = false;
    };

    const criarQrcode = async () => {
      try {
        await store.dispatch("maquina/criarQr", {
          id: paramsRota.id,
          titulo: nameQr.value,
          link: link.value,
        });

        $q.notify({
          message: "Qr code criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getQrcode();
        nameQr.value = "";
        link.value = "";
        rightDrawerOpen.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o criar Qrcode",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getQrcode);

    const handleRequest = async () => {
      getQrcode(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getQrcode();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getQrcode();
      }
    );

    return {
      columns,
      rows,
      getQrcode,
      pagination,
      handleRequest,
      disable,
      filter,
      nameQr,
      rightDrawerOpen,
      link,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      criarQrcode,
      paramsRota,
      filtros,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
